@if (loading) {
  <div class="progress-loader">
    <ng-lottie [options]="options" width="125px" height="125px" />
  </div>
}
